import React, { Component } from 'react';

class Loader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false
        };
    }

    componentDidMount() {
        // Hide loader quickly after component mounts
        setTimeout(() => {
            this.setState({ showLoader: false });
        }, 800);
    }

    render() {
        if (!this.state.showLoader) {
            return null;
        }

        return (
            <div className="preloader">
                <div className="clear-loading loading-effect-2">
                    <span></span>
                </div>
            </div>
        );
    }
}

export default Loader;